import { Rule } from '../types';

export const ruleHandrails: Rule = (submission) => {
  // CSA B651:18 §5.5.8 — MC 2 côtés obligatoires pour rampe accessibilité commerciale
  if (submission.config.usage !== 'com') return null;
  if (submission.config.railType === 'barrotin_mains') return null; // MC incluses

  return {
    ruleId: 'handrail-both-sides',
    severity: 'warn',
    humanMessage: `En commercial, mains courantes recommandées des 2 côtés (CCQ/CSA B651). Passer en "barrotin avec mains" ?`,
    suggestion: {
      type: 'add-handrail',
      patch: {
        config: { ...submission.config, railType: 'barrotin_mains' },
      },
    },
  };
};
